import React from 'react'
import Breadcrum from '../UserComponents/Partial/Breadcrum'

export default function About() {
  return (
    <>
      <Breadcrum title="About Page" />
    </>
  )
}
